export const SET_SUB_NAVBAR = 'SET_SUB_NAVBAR';

export const setSubNavbar = ({ title = [], backLink = '/', visible = true }) => ({
  type: SET_SUB_NAVBAR,
  subNavbar: {
    title,
    backLink,
    visible,
  },
});

export const enableSubNavbar = () => setSubNavbar({});
export const disableSubNavbar = () => setSubNavbar({ visible: false });
